<template>
    <Modal :small="small" @close="onClose">
        <slot/>
    </Modal>
</template>
<script>
export default {
    name: 'ModalRouteChild',
    props: {
        parent: {
            type: String,
            required: true,
        },
        resume: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClose () {
            this.$router.push({
                name: this.parent,
                query: {
                    ...this.$route.query,
                    ...(this.resume ? {
                        next: this.$route.name,
                    } : {}),
                },
            });
        },
    },
};
</script>
